import {MuseOn} from "./MuseOn";

export class Route extends MuseOn {
    _id: string;
    name: string;
    color: number;
    cover: string;
    artworks: string[];
    database_id: string;

    constructor (data) {
        super();

        this._id = data._id;
        this.name = data.name;
        this.color = data.color;
        this.cover = data.cover;
        this.artworks = data.artworks;
        this.database_id = data.database_id;
    }

    getObj(removeNull: boolean = false) {
        const result =  {
            name: this.name,
            color: this.color,
            cover: this.cover,
            database: this.database_id,
        };

        return removeNull
            ? this.removeNull(result)
            : result
        ;
    }
}
